import {
  CommunicationUserSpecificPushNotifications,
  EmailAccountAuthenticationFailedPushNotification,
} from '@lexian/api/notifications-api';
import {useEmailPushNotification} from '_/hooks/communication/useEmailPushNotification';

export function useEmailAccountAuthenticationFailedPushNotification(
  callback: (name: string, userName: string) => void | Promise<void>
): void {
  useEmailPushNotification((notification) => {
    if (isEmailAccountAuthenticationFailedPushNotification(notification)) {
      const {name, userName} = notification;
      callback(name, userName);
    }
  });
}

const isEmailAccountAuthenticationFailedPushNotification = (
  body: CommunicationUserSpecificPushNotifications
): body is EmailAccountAuthenticationFailedPushNotification =>
  body.pushNotificationType ===
  'EmailAccountAuthenticationFailedPushNotification';
